import React from 'react';
import { Route } from 'react-router';
import requireAuthentication from '@app/auth/requireAuthentication';
import Orders from './containers/Orders';

export default (
  <Route
    key="orders-route"
    path="orders"
    components={{
      content: requireAuthentication(Orders),
    }}
  />
);



// WEBPACK FOOTER //
// ./src/modules/orders/routes.jsx